import React from 'react';
import Connect from '../Connect/Connect';
import HomeTopBanner from '../HomeTopBanner/HomeTopBanner';
import Portfolio from '../Portfolio/Portfolio/Portfolio';
import Services from '../Services/Services/Services';
import Stats from '../Stats/Stats';
import Testimonials from '../Testimonials/Testimonials/Testimonials';
import TrustUs from '../TrustUs/TrustUs';

const Home = () => {
    return (
        <div>
            <HomeTopBanner />
            <Stats />
            <Services />
            <TrustUs />
            <Portfolio />
            <Testimonials />
            <Connect />
        </div>
    );
};

export default Home;